import axios from 'axios';

export class AuthService {
    login = async (username, password, remember) => {
        return await axios.post('/api/auth/login', { username: username, password: password, remember: remember });
    };

    logininfo = async (username, password, remember) => {
        return await axios.post('/api/auth/logininfo', { username: username, password: password, remember: remember });
    };
}
